import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { BxBadgeComponent, BxButtonComponent } from '@beyonnex/bx-angular-ui';
import { TranslatePipe } from '@ngx-translate/core';
import { ROUTES } from '../../../../app.models';
import { BarLoaderComponent } from '../../../../components/bar-loader/bar-loader.component';
import { TadoDraginoImportService } from '../tado-dragino-import.service';

@Component({
  selector: 'bxi-els-import-status-report',
  standalone: true,
  imports: [TranslatePipe, BxBadgeComponent, BxButtonComponent, RouterLink, BarLoaderComponent],
  templateUrl: './els-import-status-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElsImportStatusReportComponent {
  private readonly elsImportComponentStore = inject(TadoDraginoImportService);
  protected readonly deviceDetailsRoute = `/${ROUTES.DEVICE_DETAILS}`;

  protected elsJobStatistics = toSignal(this.elsImportComponentStore.elsJobStatistics$);

  protected stopMonitoring(): void {
    this.elsImportComponentStore.clearJobUrl();
  }
}
